import React, { useState, useEffect, useRef } from 'react';
import { useUsuarios } from "../State/UsuarioContext";
import { useHistory } from "react-router-dom";
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import CircularProgress from '@mui/material/CircularProgress';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const OutlinedStyled = styled(OutlinedInput)(({ theme }) => ({
    borderRadius: '50px'
}));

export default function BuscadorPorIniciales() {
    const [buscado, setBuscado] = useState('');
    const [filtro, setFiltro] = useState('uid');
    const { fetchUsuariosBuscado } = useUsuarios();
    const history = useHistory();
    const controllerRef = useRef(null);
    const timeoutRef = useRef(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (timeoutRef.current) {
            setLoading(true);
            clearTimeout(timeoutRef.current);
        }

        if (buscado === '') {
            if (controllerRef.current) {
                controllerRef.current.abort();
            }
            setLoading(false);
            return;
        }

        timeoutRef.current = setTimeout(() => {
            if (controllerRef.current) {
                controllerRef.current.abort();
            }

            const controller = new AbortController();
            controllerRef.current = controller;

            fetchUsuariosBuscado(buscado, controller.signal, filtro)
                .catch((error) => {
                    if (error.name !== 'AbortError') {
                        console.error(error);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });

        }, 1000);

        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, [buscado, filtro]);

    const handleChange = (e) => {
        const value = e.target.value;
        setBuscado(value);
        history.push({ search: `?search=${value}&filtro=${filtro}` });
    };

    const handleFiltroChange = (event) => {
        setFiltro(event.target.value);
    };

    return (
        <Box sx={{
            marginTop: '2vh',
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2
        }}>
            <Box sx={{ flex: 3 }}>
                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-search">Buscador</InputLabel>
                    <OutlinedStyled
                        value={buscado}
                        onChange={handleChange}
                        id="outlined-adornment-search"
                        label="Buscador"
                        endAdornment={
                            <InputAdornment position="end">
                                <SearchIcon />
                                {loading && (
                                    <Box sx={{ ml: 1 }}>
                                        <CircularProgress size={20} />
                                    </Box>
                                )}
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
            <Box sx={{ flex: 1, width: "100%" }}>
                <FormControl fullWidth>
                    <InputLabel id="filtro-label">Filtrar por</InputLabel>
                    <Select
                        labelId="filtro-label"
                        id="filtro-select"
                        value={filtro}
                        label="Filtrar por"
                        onChange={handleFiltroChange}
                    >
                        <MenuItem value="document">Documento</MenuItem>
                        <MenuItem value="uid">UID</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Box>
    );
}
